import { memo, ReactNode } from "react";
import { Card, CardContent, CardHeader, Grid2, Typography, SxProps, Box } from "@mui/material";

interface SettingsCardProps {
    title?: string;
    subtitle?: string;
    children: ReactNode;
    action?: ReactNode;
    sx?: SxProps;
    headerSx?: SxProps;
    contentSx?: SxProps;
    onSave?: () => void;
    gridSpacing?: number;
    useGrid?: boolean;
}

const SettingsCard = memo(({ title, subtitle, children, action, sx, headerSx, contentSx, gridSpacing = 3, useGrid = false }: SettingsCardProps) => {
    return (
        <Card sx={{ bgcolor: "semantic.surface.primary", width: "100%", ...sx }} elevation={0}>
            {(title || action) && (
                <CardHeader
                    title={
                        <Typography variant="h5" color="semantic.text.heading">
                            {title}
                        </Typography>
                    }
                    subheader={subtitle}
                    action={action}
                    sx={{
                        pb: subtitle ? 1 : 0,
                        ...headerSx,
                    }}
                />
            )}
            <CardContent sx={contentSx}>
                {useGrid ? (
                    <Grid2 container size={12} spacing={gridSpacing}>
                        {children}
                    </Grid2>
                ) : (
                    <Box>{children}</Box>
                )}
            </CardContent>
        </Card>
    );
});

export default SettingsCard;
